import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { ModelGhost } from "oc-jaco3d/arrangement/ModelGhost";
import { quatEuler, v3 } from "oc-threejs/short3";
import * as Maths3 from "oc-threejs/Maths3";
import { getMMR } from "../RichMetadata";
import _ from "lodash";
import { heightBoxWorldPhysical } from "../commons/Utils";
import { MObjekt } from "../../metamodell";
import { ZElement } from "./ZElement";
import { Flügel } from "./Flügel";
import { StücklistenIterator } from "./Stückliste";
import { Box3 } from "three";
import { ghostPool } from "./Arrangement";

export class Rahmen extends Jaco {
  static CLASS_NAME = "Rahmen";

  meta: MObjekt = null;
  modelle: ModelGhost[] = [];
  size = v3();
  box = new Box3();
  innenBox = new Box3();
  element: ZElement;
  flügel: Flügel;
  // physikalische Höhe der obersten Kante über dem Erdboden

  constructor(parent: any, flügel: Flügel, element: ZElement) {
    super(parent);
    this.element = element;
    this.flügel = flügel;
  }

  traverse(iterator: (jaco: Jaco) => void) {
    super.traverse(iterator);
    if (this.modelle) this.modelle.forEach((o) => o.traverse(iterator));
  }

  getBox() {
    return this.box.clone();
  }

  update3d() {
    super.update3d();
    Maths3.boxFromGridMinAndSize(v3(0, 0, 0.5), this.size, this.box);
    this.modelle = ghostPool(this).clearInstances(this.modelle);
    this.updateRahmen();
    this.modelle.forEach((m) => m.update3d());
    Maths3.boxFromGridMinAndSize(v3(0, 0, 0.5), this.size, this.box);
  }

  addModel(mmr, sizeX, gehrung45) {
    const model = ghostPool(this).getForModelMaterialRelation(this, mmr, {
      size: v3(sizeX, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
      fixGridPosition: v3(0.5, 0.5, 0.5),
      gehrung45,
    });
    this.modelle.push(model);
    return model;
  }

  updateRahmen() {
    if (this.element.isSchiebetor) {
      return;
    }
    // Konvention für Gridposition der Modelle: 0.5,0.5,0.5
    const mmr = getMMR(this.meta);
    if (mmr == null) {
      debugger;
      getMMR(this.meta);
    }
    const modelSize = APP.modelsHelper.getBoundingBox(mmr).getSize(v3());
    this.size.z = modelSize.z;

    const rahmenNurSeitlich = this.meta.Querleistenwerte?.[0].RahmenNurSeitlich;
    const addRahmen = (sizeX, rotationZ, partPos, boxGridPos) => {
      const part = this.addModel(mmr, sizeX, true);
      part.quaternion.copy(quatEuler(0, 0, rotationZ));
      const bgp = this.box.grid(boxGridPos);
      part.position.copy(bgp).sub(partPos);
    };
    const hy = modelSize.y / 2;

    this.innenBox
      .copy(this.box)
      .expandByVector(v3(-modelSize.y, rahmenNurSeitlich ? 0 : -modelSize.y, 0));

    if (!rahmenNurSeitlich) {
      // bottom
      addRahmen(this.size.x, 0, v3(0, -hy, 0), v3(0.5, 0, 0.5));
      // top
      addRahmen(this.size.x, 180, v3(0, hy, 0), v3(0.5, 1, 0.5));
    }
    // left
    addRahmen(this.size.y, 270, v3(-hy, 0, 0), v3(0, 0.5, 0.5));
    // right
    addRahmen(this.size.y, 90, v3(hy, 0, 0), v3(1, 0.5, 0.5));
  }

  collectArtikel(
    iterator: StücklistenIterator,
    ObjectGroupTag: string = undefined,
    JacoId: number | undefined = undefined
  ) {
    iterator({ ObjektMeta: this.meta, ObjectGroupTag, JacoId });
  }

  get heightPhysical() {
    return _.max(this.modelle.map(heightBoxWorldPhysical));
  }
}
